import React from "react";
import cv from '../assets/SanjayKumar.pdf';

function Header() {
  return (
    <>
      <section id="about" className=" bg-dark-1">
        <div className="container">
          <div className="section-head ">
            <h2>ABOUT ME</h2>
            <h3>
              Know Me More <span className="border2"></span>
            </h3>
          </div>
          <div class="row">
            <div class="col-md-12 col-xl-8 pt-5">
              <h1>
               <span className="clr">Sanjay Kumar</span>, <br/>
                <span className="subhead">Senior Frontend Developer |  React | UI/UX</span></h1>
              <p className="py-2 mt-3">
              Senior Frontend Developer with 13+ years of experience designing and developing scalable, high-performance web applications using React, javaScript, HTML5, CSS3, Bootstrap, and Tailwind CSS.   
              </p>

              <p className="py-2">
                Experienced in translating Figma designs into pixel-perfect user interfaces, building reusable component libraries, integrating REST APIs, optimizing application performance, and collaborating with cross-functional teams to deliver enterprise-grade solutions.
              </p>
             



            </div>
            <div class="col-md-12 col-xl-4  mt-3">
            
              <ul class="list">
                
                  <li ><span>Email : </span> <a href="mailto:sanjayparit19@gmail.com" target="new">sanjayparit19@gmail.com</a></li>
                  <li ><span>Phone : </span>  91-9199195513</li>
                  <li><span>Address : </span>  Sagarpur, New Delhi - 110046</li>
                  
                  <a className="btn btn-outline-info mt-3" href={cv} download='SanjayKumarCV.pdf'>Download CV</a>
                </ul>


 



            </div>
          </div>

     <div className="box-container">

          <div className="box">
            <h4>13+</h4>
            <p>Years of Experience</p>
          </div>
          <div className="box">
            <h4>100+</h4>
            <p>Projects Delivered</p>
          </div>
          <div className="box">
            <h4>200+</h4>
            <p>Responsive Pages</p>
          </div>
            <div className="box">
            <h4>500+ </h4>
            <p>Reusable Components</p>
          </div>


     </div>


   
        </div>
      </section>
    </>
  );
}

export default Header;
